
import React from "react";
import ChartsTabsContainer from "./charts/ChartsTabsContainer";
import PlanDistribution from "./charts/PlanDistribution";
import ConversionRate from "./charts/ConversionRate";

const AdminStatistics = () => {
  return (
    <div className="space-y-8 mt-8">
      <ChartsTabsContainer />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <PlanDistribution />
        <ConversionRate />
      </div>
    </div>
  );
};

export default AdminStatistics;
